import { LicenseType } from "../components/manage-template/manage-template.model";
import { CreatedBy, Privacy, TemplateCategory } from "./template.model";

export interface CustomTemplateReq {
    name: string;
    description: string;
    category: TemplateCategory;
    privacy: Privacy;
    promptHeader: string,
    promptBody: string,
    promptFooter: string
}

export interface TemplateListing {
    name: string;
    description: string;
    category: TemplateCategory;
    privacy: string;
    createdBy: CreatedBy;
    createdAt: Date;
    starred: boolean;
    isCustomTemplate: boolean;
    identifier: string;
}

export interface TemplateDetail {
    identifier: string,
    name: string,
    description: string,
    category: TemplateCategory,
    privacy: Privacy,
    promptHeader: string,
    promptBody: string,
    promptFooter: string

}

export interface ITab {
    title: string,
    controlName: string,
    isEditable?: boolean;
    suffix?: number;
    identifier: string;
  }

export enum TemplateIdentity {
    ExistingNoteText = 'existing_note_text',
    ExistingNoteFile = 'existing_note_file',
    FromPrompt = 'from_prompt',
    BlankTemplate = 'blank_template'
}


export interface TemplateOptionItem {
    title: string;
    description: string;
    identity: TemplateIdentity;
}

export interface FavTemplateRequest {
    templateIdentifier: string;
    isCustomTemplate: boolean;
    isFavorite: boolean;
}

export const templateOptionListing: TemplateOptionItem[] = [
    {
        title: 'Template from Existing Note (Text)',
        description: 'Generate a template by extracting text from an existing note.',
        identity: TemplateIdentity.ExistingNoteText
    },
    {
        title: 'Template from Existing Note (File)',
        description: 'Generate a template by extracting content from an existing note file.',
        identity: TemplateIdentity.ExistingNoteFile
    },
    {
        title: 'Template from Prompt',
        description: 'Generate a template based on a user-defined prompt.',
        identity: TemplateIdentity.FromPrompt
    },
    {
        title: 'Blank Template',
        description: 'Create a blank template to start from scratch.',
        identity: TemplateIdentity.BlankTemplate
    }
];

export interface FavTemplateRequest {
    templateIdentifier: string;
    isCustomTemplate: boolean;
    isFavorite: boolean;
}

export interface CustomTemplatePreview {
    transcription?: string;
    prompt: string;
}

export interface PromptResponse {
    promptHeader: string;
    promptBody: string;
    promptFooter: string;
}

export interface SubscriptionDetails {
    dt1: string;
    dt2: string;
    uno: string;
    userCount: number;
    durationType?: string;
    price?: string;
    notify?: number;
    licenseType: LicenseType;
}

export const iconMapping: { [key in TemplateCategory | 'Favorites']?: string } = {
    [TemplateCategory.NOTE]: "mat_outline:note_alt",
    [TemplateCategory.DOCUMENT]: "mat_outline:description",
    [TemplateCategory.LETTER]: "mat_outline:assignment",
    ['Favorites']: "mat_outline:star_border"
};